export const DASHBOARD_QUERY_PARAM_STATE = 's';